// generated from 44_101 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const hasAppFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("has_app_filter"),
  comparison_key: z.enum([
    "1", // 38_133 (86.47%)
    "2", // 5_968 (13.53%)
  ]),
  display_name: z.string(),
  // undefined: 19_964 (45.27%), defined 24_137 (54.73%)
  raw_value: common.objectId.optional(),
  value: z.object({
    // undefined: 43_088 (97.70%), defined 1_013 (2.30%)
    deleted_app: z.literal(true).optional(),
    id: common.objectId,
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
